"use strict";

import {Dispatcher} from "flux";

/******************************************************************************
** FormComponentBase
*/

export default class FormContext {

	constructor(form) {
		this.form = form;
		this.dispatcher = new Dispatcher();
	}

	getFormClientId() {
		return this.form.state.clientId;
	}

	getFormKey() {
		return this.form.props.formKey;
	}

	getFormDimensions() {
		return this.form.state.dimensions;
	}

	setFormState(values) {
		this.form.setState(values);
	}

	getFormState() {
		return this.form.state;
	}

}



/** WEBPACK FOOTER **
 ** ./forms/FormContext.js
 **/